/**
 * @generated SignedSource<<38d0a0b92167c8842c02f2805c4131bc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type RoundInfoBannersQuery$variables = {
  membershipTypeId: string;
  rateId: string;
};
export type RoundInfoBannersQuery$data = {
  readonly rateNode: {
    readonly appliesToMembershipType?: boolean | null | undefined;
  } | null | undefined;
};
export type RoundInfoBannersQuery = {
  response: RoundInfoBannersQuery$data;
  variables: RoundInfoBannersQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "membershipTypeId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "rateId"
},
v2 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "rateId"
  }
],
v3 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "membershipTypeId",
          "variableName": "membershipTypeId"
        }
      ],
      "kind": "ScalarField",
      "name": "appliesToMembershipType",
      "storageKey": null
    }
  ],
  "type": "Rate",
  "abstractKey": "__isRate"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "RoundInfoBannersQuery",
    "selections": [
      {
        "alias": "rateNode",
        "args": (v2/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "RoundInfoBannersQuery",
    "selections": [
      {
        "alias": "rateNode",
        "args": (v2/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f04af24cfcd2710f0f75b3c7b0ab6b20",
    "id": null,
    "metadata": {},
    "name": "RoundInfoBannersQuery",
    "operationKind": "query",
    "text": "query RoundInfoBannersQuery(\n  $rateId: ID!\n  $membershipTypeId: ID!\n) {\n  rateNode: node(id: $rateId) {\n    __typename\n    ... on Rate {\n      __isRate: __typename\n      appliesToMembershipType(membershipTypeId: $membershipTypeId)\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "d3c723083fafd9d4265d20b2c667ed96";

export default node;
